import React, { useEffect } from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';

import { BackNextButtons } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/common';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING_BUDGET } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useAppSelector, useHistory } from 'src/utils/Hooks';
import _isEmpty from 'lodash/isEmpty';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import { useAllocationData } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation/BudgetAllcationData';
import ActivePortfolios from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation/ActivePortfolios';
import InActivePortfolios from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation/InActivePortfolios';
import { AdManagerPortfolio } from 'src/types/store/reduxStore';

const BudgetAllocation = () => {
  const history = useHistory();
  const { queryParams } = useAppSelector((state) => state.app);
  const { searchParams } = queryParams;
  const { mainEntity } = useAppSelector((state) => state.entityService);

  const { hashId } = mainEntity;
  const selectedEntity = useAppSelector((state) => state.adBudgetEditor.entity);
  const selectTimeline = useAppSelector((state) => state.adBudgetEditor.timeline);

  const hasEntityData = !_isEmpty(selectedEntity) && !!selectTimeline;

  const canMoveNext = true;
  const { activePortfolios, inActivePortfolios } = useAllocationData((store) =>
    store?.filter((portfolio: AdManagerPortfolio) => {
      return portfolio?.additionalMetaData?.portfolio?.entityId === selectedEntity?.entityId;
    })
  );

  useEffect(() => {
    if (!hasEntityData) {
      history.push(`/client/${hashId}${searchParams}&tab=advertising&subtab=budgetEntity`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEntityData]);

  const onNextClick = () => {
    history.push(`/client/${hashId}${searchParams}&tab=advertising&subtab=${BEACON_SUBTABS.BUDGET_CONFIRMATION}`);
  };

  const onBackClick = () => {
    history.push(`/client/${hashId}${searchParams}&tab=advertising&subtab=${BEACON_SUBTABS.BUDGET_ENTITY}`);
  };

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING_BUDGET}>
        <ActivePortfolios data={activePortfolios} />
        <InActivePortfolios data={inActivePortfolios} />
        <BackNextButtons canMoveBack canMoveNext={canMoveNext} onNextClick={onNextClick} onBackClick={onBackClick} />
      </Flex>
    </BasePageContainer>
  );
};

export default BudgetAllocation;
